import { Link } from "react-router-dom";
import { Target, Truck, HeartHandshake, Award } from "lucide-react";

const values = [
  [Target, "Specialist Focus", "Carp is our passion, but we cater for coarse, predator and sea anglers too — with genuine bankside knowledge behind every product."],
  [Truck, "Fast & Fair", "Keen prices, fast UK dispatch and free delivery over £50. Get your gear when you need it."],
  [HeartHandshake, "Angler First", "Real advice from real anglers. We only stock kit we'd happily use ourselves."],
  [Award, "Trusted Brands", "From Fox and Nash to Sticky Baits and Korda — the best names, all in one place."],
];

export default function About() {
  return (
    <div>
      <section className="relative flex min-h-[55vh] items-center">
        <img src="https://images.unsplash.com/photo-1778016740380-21c3277768f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="Misty lake" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-background/20" />
        <div className="container-furn relative">
          <span className="overline">Our Story</span>
          <h1 className="mt-3 max-w-2xl font-display text-4xl font-bold uppercase leading-tight md:text-6xl">Built by anglers, for anglers</h1>
        </div>
      </section>

      <section className="container-furn py-16">
        <div className="grid gap-10 lg:grid-cols-2">
          <div className="space-y-5 text-lg leading-relaxed text-foreground/85">
            <p>Furn Angling was born out of a simple frustration — the best specialist tackle should be easy to find, fairly priced, and backed by people who actually fish.</p>
            <p>Based in South Woodham Ferrers, Essex, we're a specialist fishing tackle retailer with carp angling at our core. Whether you're chasing a new personal best, fishing your local commercial, or heading to the coast, we've got the gear and the know-how to help.</p>
            <p>We stock the brands the UK's leading anglers trust, and we're always on the bank ourselves — testing, learning and sharing what works.</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {values.map(([Icon, t, d]) => (
              <div key={t} className="border border-border bg-card p-6">
                <Icon className="h-7 w-7 text-accent" />
                <h3 className="mt-3 font-display text-lg font-semibold">{t}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{d}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 border border-border bg-card p-8 text-center">
          <h2 className="font-display text-3xl font-bold uppercase">Visit us in store</h2>
          <p className="mt-3 text-muted-foreground">Unit 10, Blackhall Industrial Park, South Woodham Ferrers, CM3 5UW · sales@furnangling.co.uk</p>
          <Link to="/shop" className="mt-6 inline-block bg-accent px-8 py-4 text-xs font-bold uppercase tracking-widest text-accent-foreground">Shop the range</Link>
        </div>
      </section>
    </div>
  );
}
